<div class="{{ marginTopCss }}">
  <p
    #collapsible
    class="{{ textCss || '' }} mb-1"
    [ngClass]="showMoreText ? 'clamp-2' : ''"
    [innerHTML]="textKey | translate"
    [id]="uuid"
    [attr.aria-expanded]="!showMoreText"
  ></p>
  <p class="mb-0">
    <button
      class="btn btn-link btn-link--dark-blue"
      mweClickPreventDefault
      (click)="toggleText()"
      [attr.aria-expanded]="!showMoreText"
      [attr.aria-controls]="uuid"
    >
      <span class="text-decoration-underline">{{ (showMoreText ? showMoreKey : showLessKey) | translate }}</span>
    </button>
  </p>
</div>
